import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SeusStatusService } from '../services/seus-status.service';

@Injectable()
export class SeusAvailabilityGuard implements CanActivate {
  
  constructor(
    private seusStatusService: SeusStatusService,
    private router: Router
  ) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const status = this.seusStatusService.getCurrentStatus();
    
    if (!status.available) {
      // SEUS no está disponible, redirigir a acceso-denegado
      this.router.navigate(['acceso-denegado'], {
        queryParams: {
          tipo: status.errorType || 'network',
          status: status.errorStatus || 0
        }
      });
      return false;
    }
    
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/seus-availability.guard.ts